export default {
  api_r_open_userAccessCode_checkCode: {
    path: 'user-access-code/check-code/',
  },
  api_r_open_userAccessCode_downloadDocument: {
    path: 'user-access-code/download-document/',
  },
  api_r_open_userAccessCode_signup: {
    path: 'user-access-code/signup/',
  },
};
